let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("81vUc")).then(() => parcelRequire('ifsVi'));